import Api from '../Helper/Api';

class DescriptionAction {



    description(data) {

        let resp = Api.postApi3(data, 'live-streaming');
        console.log(resp)
        return resp
    }


}

export default DescriptionAction.prototype;